jQuery(document).ready(function($) {
    
	fitvids('.video-container');
 
});
